import { IAppDataLoader, IAppInitParams } from "app/model"
import { dspRPO } from "dsp/repository"
import { canAccessDspDeal } from "user/tools/permissions"

export const dspDataLoader: IAppDataLoader = async (params: IAppInitParams, onFinish: (error?: string) => any) => {
  try {
    if (!canAccessDspDeal()) {
      onFinish()
      return
    }
    const dsps = await dspRPO.getAllDsp()
    params.dsps = dsps
    onFinish()
  } catch (error) {
    console.error(error)
    onFinish(`Unexpected error while loading dsp data: ${error}`)
  }
}
